module.exports = __webpack_public_path__ + "img/age-appropriate-min.e541f6ce.jpg";